export const LOCATION_GROUPS_QUERY_KEY = 'locationGroups'
export const ARCHIVED_LOCATION_GROUPS_QUERY_KEY = 'archivedLocationGroups'
